<template>
  <div class="bb-px2pt6 bb-pb2pt56 border-box bb-w100p">
    <div class="bb-w100p bb-h0pt1 bb-bc13 absolute left-0 right-0"></div>
    <div class="bb-mt2pt56">
      <div class="lg-col center mb4 bb-lg-mb0">
        <div class="bb-lg-inline-block mb3 bb-lg-mb0 bb-ff3 bb-fs1 bb-lg-mr4">
          <router-link :to="{name: 'RefundPolicy'}" class="text-decoration-none bb-fc2-hover bb-transition2" 
          :class="[$route.name === 'RefundPolicy' ? 'bb-fc2' : 'bb-fc3']">
            Refund Policy
          </router-link>
        </div>
        <div class="bb-lg-inline-block mb3 bb-lg-mb0 bb-ff3 bb-fs1 bb-lg-mr4">
          <router-link :to="{name: 'PrivacyPolicy'}" class="text-decoration-none bb-fc2-hover bb-transition2"
          :class="[$route.name === 'PrivacyPolicy' ? 'bb-fc2' : 'bb-fc3']">
            Privacy Policy
          </router-link>
        </div>
        <div class="bb-lg-inline-block mb3 bb-lg-mb0 bb-ff3 bb-fs1 bb-lg-mr4">
          <router-link :to="{name: 'ContactUs'}" class="
          text-decoration-none bb-fc2-hover bb-transition2"
          :class="[$route.name === 'ContactUs' ? 'bb-fc2' : 'bb-fc3']">
            Contact Us
          </router-link>
        </div>
      </div>
      <div class="lg-col-right center">
        <div v-for="(socialMediaObj, i) in socialMediaData" class="inline-block">
          <a class="block relative"
            :class="[ i !== 0 ? 'bb-ml5 bb-lg-ml3' : '' ]"
            :href='socialMediaObj.url'
            target="_blank">
            <img :class="socialMediaObj.widthClass" :src='imagePath(socialMediaObj.imgUrl)'>
            <img :class="socialMediaObj.widthClass" :src='imagePath(socialMediaObj.imgUrlHovered)'
              class="absolute left-0 top-0 bb-op0 bb-op1-hover bb-transition1">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      socialMediaData: [
        {
          'url': 'https://facebook.com/BbangStudios/',
          'imgUrl': '/icons/facebook.svg',
          'imgUrlHovered': '/icons/facebook_pink.svg',
          'widthClass': 'bb-w0pt7'
        },
        {
          'url': 'https://www.instagram.com/bbangstudios/',
          'imgUrl': '/icons/instagram.svg',
          'imgUrlHovered': '/icons/instagram_pink.svg',
          'widthClass': 'bb-w1pt25'
        }
      ]
    }
  },
  methods: {
    imagePath: function (imgPath) {
      return require('../assets' + imgPath)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue